<script>
  import { v4 as uuidv4 } from "uuid";
  import { onMount } from "svelte";
  import { gsap } from "gsap";
  import InfoBlock from "./InfoBlock.svelte";
  import Title from "./Title.svelte";

  export let full = false;
  export let light = false;
  export let dark = false;

  const componentId = "resistance__" + uuidv4();
</script>

<div class="resistance {$$props.class}" id={componentId}>
  <Title title={"Resistance"} {dark} />
  <div class:resistance__container--full={full}>
    {#if full || light}
      <div class="resistance__image resistance__image--light">
        <img src="https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/background_resistance_light.png" />
      </div>
    {/if}
    {#if full || dark}
      <div class="resistance__image resistance__image--dark">
        <img src="https://assets.decathlon.site/6957288d9682339eec0ccd1ecfed712a/landing/shoes-10/assets/img/background_resistance_dark.png" />
      </div>
    {/if}
  </div>
  <div class:resistance__container--full={full}>
    {#if full || light}
      <div class="resistance__info-block--light">
        <InfoBlock
          title={"ZONES KPU"}
          text={"Placées aux zones de frottements et d’usures extrêmes, le KPU apporte la touche de résistance supplémentaire à vos nombreux déplacements. Il est présent sur les 2 paires."}
          alignRight={full}
        />
      </div>
    {/if}
    {#if full}
      <div class="resistance__title">
        <Title title={"&"} {dark} />
      </div>
    {/if}
    {#if full || dark}
      <div class="resistance__info-block--dark">
        <InfoBlock
          title={"RUBLAST"}
          text={"Caoutchouc utilisé pour la semelle. Ultra-résistant et soumis aux tests d’abrasion en laboratoire, il garantit une excellente durabilité des TS 990 et TS 960. À vous les 5ème sets !"}
          dark
        />
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  $black: #131111;
  $white: #ffffff;

  .resistance {
    align-items: center;
    display: flex;
    flex-direction: column;

    &__image {
      margin-top: -2rem;

      img {
        max-width: 100%;
      }
    }

    &__info-block {
      &--light {
        padding-right: 2rem;
      }

      &--dark {
        padding-left: 2rem;
      }
    }

    &__container--full {
      display: flex;
      width: 100%;
    }

    &__title {
      transform: scale(1.5) translate(6%, 10%);
    }
  }
</style>
